"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOas3Operation = exports.transformOas3Operations = void 0;
const pickBy = require("lodash.pickby");
const guards_1 = require("../guards");
const oas_1 = require("../oas");
const context_1 = require("../oas/context");
const callbacks_1 = require("./transformers/callbacks");
const request_1 = require("./transformers/request");
const responses_1 = require("./transformers/responses");
const securities_1 = require("./transformers/securities");
const servers_1 = require("./transformers/servers");
function transformOas3Operations(document, ctx) {
    return (0, oas_1.transformOasOperations)(document, exports.transformOas3Operation, void 0, ctx);
}
exports.transformOas3Operations = transformOas3Operations;
const transformOas3Operation = ({ document: _document, path, method, ctx = (0, context_1.createContext)(_document), }) => {
    const httpOperation = oas_1.transformOasOperation.call(ctx, path, method);
    const pathObj = ctx.maybeResolveLocalRef(ctx.document.paths[path]);
    const operation = ctx.maybeResolveLocalRef(pathObj[method]);
    return {
        ...httpOperation,
        responses: responses_1.translateToResponses.call(ctx, operation.responses),
        request: request_1.translateToRequest.call(ctx, pathObj, operation),
        security: securities_1.translateToSecurities.call(ctx, operation.security),
        servers: servers_1.translateToServers.call(ctx, pathObj, operation),
        ...pickBy({
            callbacks: callbacks_1.translateToCallbacks.call(ctx, operation.callbacks),
        }, guards_1.isNonNullable),
    };
};
exports.transformOas3Operation = transformOas3Operation;
//# sourceMappingURL=operation.js.map